import {
	CREATE_REF_SYMBOL,
	CREATE_REF_SUBSCRIBE_SYMBOL,
	CREATE_REF_COMP_PROPS_SUBSCRIPTIONS_SYMBOL
} from '../constants';
/**
 * Creates a react-like ref.
 * @method createRef
 * @returns {{current: null}}
 */
export default function createRef() {
	let current = null;
	const subscriptions = new Map();
	const ref = {
		[CREATE_REF_SYMBOL]: true,
		set current(val) {
			if (current !== val) {
				current = val;
				for (const [component, props] of subscriptions) {
					for (const name of props) component[name] = val;
				}
			}
		},
		get current() {
			return current;
		},
		[CREATE_REF_SUBSCRIBE_SYMBOL](component, propertyName) {
			subscriptions.set(component, (subscriptions.get(component) || new Set()).add(propertyName));
			return () => {
				const propList = subscriptions.get(component);
				propList?.delete(propertyName);
				propList?.size === 0 && subscriptions.delete(component);
			};
		},
		[CREATE_REF_COMP_PROPS_SUBSCRIPTIONS_SYMBOL](component) {
			const compSubscriptions = subscriptions.get(component);
			return compSubscriptions ? [...compSubscriptions] : [];
		}
	};
	Object.seal(ref);
	return ref;
}
